import React from "react"
import { Helmet } from "react-helmet"
import { useParams, useHistory } from "react-router-dom"

import makeCityFromSlug from "../../utils/makeCityFromSlug"
import { makeApiCall } from "../../utils/gatewayUtils"
import { stateMarketing } from "../../content"
import Loading from "../template-parts/Loading"
import LocationLandingContent from "../template-parts/LocationLandingContent"
import GenericLandingHero from "../sections/GenericLandingHero"
import apiConfig from "../../apiConfig"
import { NUM_REVIEWS } from "../../config"

const DEFAULT_STATE = "ca"

const Location = () => {
  const { state, id: locationId } = useParams<{ state: string; id: string }>()
  const history = useHistory()
  const city = makeCityFromSlug(locationId)

  React.useEffect(() => {
    /**
     * If we don't have a state in the URL, figure out what the state
     * should be and redirect them to the correct URL.
     */
    if (state) return

    const redirectToState = (fetchedState: string) => {
      const newUrl = `/${fetchedState}/location/${locationId}`
      history.push(newUrl)
    }

    const fetchInfo = {
      method: "GET",
    }
    makeApiCall(`${apiConfig.stateFromCity(city)}`, fetchInfo)
      .then((maybeState) => {
        const fetchedState =
          maybeState.state === "not-found" ? DEFAULT_STATE : maybeState.state
        redirectToState(fetchedState)
      })
      .catch(() => {
        redirectToState(DEFAULT_STATE)
      })
  }, [city, state, history, locationId])

  if (!state) return <Loading />

  return (
    <>
      <Helmet>
        <title>{`${city} Driving School`}</title>
        <link
          rel="canonical"
          href={`https://coastlineacademy.com/${state.toLowerCase()}/location/${locationId}`}
        />
        <meta
          name="description"
          content={`Coastline Academy is a ${city} driving school: online drivers ed, driving courses and behind-the-wheel driving lessons with certified driving instructors. Pickup & dropoff available in most areas. Backed by over ${NUM_REVIEWS} 5-star reviews.`}
        />
      </Helmet>
      <LocationLandingContent
        city={city}
        state={state}
        doShowLessonCouponsBanner
      >
        <GenericLandingHero
          title={`Driving Lessons in ${city}`}
          link={`/${state.toLowerCase()}/location-search/${locationId}`}
          intro={stateMarketing[state].landingPageIntro}
        />
      </LocationLandingContent>
    </>
  )
}

export default Location
